<template>
  <router-view v-slot="{ Component, route }">
    <component :is="Component" v-show="!authChecking" :key="route.matched[0]?.path === '/manage' ? '/manage' : route.path" />
  </router-view>
  <section v-if="authChecking" class="auth-check-status" role="status" aria-live="polite">
    <div class="auth-check-card">
      <img src="./assets/logo_light_bg.svg" alt="MicroQuake" width="200" />
      <span class="auth-check-spinner" aria-hidden="true"></span>
      <h1>{{ authStore.loggingOut ? '正在退出' : '正在确认登录状态' }}</h1>
      <p>{{ authStore.loggingOut ? '即将返回登录页面' : '正在连接你的工作空间，请稍候' }}</p>
    </div>
  </section>
  <aside v-if="verificationNotice" class="identity-retry-notice" role="status">
    <span>暂时无法核验登录状态，当前页面已保留。</span>
    <button class="button compact" type="button" :disabled="!!authStore.userInfoRequest" @click="retryIdentity">{{ authStore.userInfoRequest ? '正在核验…' : '重新核验' }}</button>
  </aside>
  <aside v-if="pageNotice" class="page-update-notice" role="status">
    <span>{{ pageNotice.message }}</span>
    <button class="button primary compact" type="button" @click="reloadPage">{{ pageNotice.action }}</button>
  </aside>
</template>

<script>
import { useAuthStore } from './store/auth'

export default {
  name: 'App',
  setup() { return { authStore: useAuthStore() } },
  data: () => ({ pageNotice: null }),
  computed: {
    authChecking() {
      // 首次无身份时门禁遮挡；已有身份的后台复核保留页面。
      if (this.$route.path === '/login') return false
      return !!this.authStore.loggingOut || (!this.authStore.userInfo &&
        (!this.authStore.initialized || !!this.authStore.userInfoRequest || !!this.$route.meta.requiresAuth))
    },
    verificationNotice() {
      return this.$route.path !== '/login' && !!this.authStore.userInfo &&
        !!this.authStore.errorStatus && ![401, 403].includes(this.authStore.errorStatus)
    }
  },
  mounted() {
    window.addEventListener('microquake:page-update', this.showPageNotice)
  },
  beforeUnmount() {
    window.removeEventListener('microquake:page-update', this.showPageNotice)
  },
  methods: {
    retryIdentity() { window.dispatchEvent(new Event('microquake:recheck-identity')) },
    showPageNotice(event) { this.pageNotice = event.detail },
    reloadPage() { window.location.replace(this.pageNotice.href) }
  }
}
</script>

<style>
@import './assets/css/main.css';

#app {
  width: 100%;
  min-height: 100dvh;
  margin: 0;
  padding: 0;
}

.auth-check-status {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  margin: 0;
  background: #f5f8fc;
  color: #172b46;
  z-index: 1100;
}

.auth-check-card { width: min(420px, calc(100vw - 40px)); box-sizing: border-box; padding: 40px 24px; text-align: center; border: 1px solid #e0e8f2; border-radius: 24px; background: #fff; box-shadow: var(--shadow-md); }
.auth-check-card img { max-width: 100%; height: auto; }
.auth-check-card h1 { margin: 20px 0 8px; font-size: 20px; }
.auth-check-card p { margin: 0; font-size: 14px; color: #5a6b80; }
.auth-check-spinner { display: block; width: 24px; height: 24px; margin: 28px auto 0; border: 2px solid #dbe7f7; border-top-color: #2563eb; border-radius: 50%; animation: auth-spin 1s linear infinite; }
@keyframes auth-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .auth-check-spinner { animation: none; } }
.identity-retry-notice { position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); z-index: 1090; display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 12px; width: max-content; max-width: calc(100vw - 32px); box-sizing: border-box; padding: 12px 16px; border: 1px solid var(--border); border-radius: 12px; color: var(--text-primary); background: var(--surface-raised); box-shadow: var(--shadow-md); font-size: 14px; }

.page-update-notice {
  position: fixed;
  bottom: calc(24px + env(safe-area-inset-bottom));
  right: 24px;
  z-index: 1100;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  max-width: calc(100vw - 48px);
  padding: 16px 20px;
  color: var(--text-primary);
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
}
</style>
